import { original } from '@reduxjs/toolkit'
import { Popover } from 'antd'
import * as Types from 'Types'
import BaseTreeNode from './BaseTreeNode'
import InitiateTypeService from 'Services/InitiateTypeService'
import { store } from '~/Store'
import { ContextMenu, showActionsPage } from 'Components'
import {
  getAttributeKeys,
  getMemberKey,
  getMemberKeys,
  getNamespaceLabel,
  getUid
} from 'Services/WeaverUtils'
import { createRoot, getCurrentTimeInMillis, getUpdatedSearchParams } from './shared'
import { setRootData, updateNodeData, updateTreeData } from 'Actions/homeTree'
import { setCurrentItem, setTabDisabled } from 'Actions/explore'

getTypes = (props) ->
  if getMemberKeys().length is 1
    { branches: { currentBranch }} = store.getState()
    types = await Weaver.MetaQueries.typesAndCount(
      getAttributeKeys(), getMemberKey(), { limit: 99999, branch: currentBranch or 'main' }
    )
    props.memberKey = getMemberKey()
    types.map((type) -> typeTreeNode(type, props))
  else
    getMemberKeys().map((key) -> memberKeyTreeNode(key))

RootTitle = () ->
  if getMemberKeys().length > 1
    <Popover
      placement="right"
      content={<span>More than one member key is defined in the <b>Data</b> panel</span>}
      title="Multiple member keys defined"
      trigger="click"
    >
      <span className="left-panel-tree-item">
        Types
      </span>
    </Popover>
  else
    <span className="left-panel-tree-item">
      Types
    </span>

typesRootTitle = () -> <RootTitle />

export typesRoot = createRoot(typesRootTitle, Types.TYPES, 'all_types', getTypes, Types.USERMODES.ADVANCED)

getNestedTypes = (props) ->
  { branches: { currentBranch }} = store.getState()
  types = await Weaver.MetaQueries.typesAndCount(
    getAttributeKeys(), props.memberKey, { limit: 99999, branch: currentBranch or 'main'}
  )
  types.map((type) -> typeTreeNode(type, props))

export memberKeyTreeNode = (memberKey) ->
  {
    title: (
      <BaseTreeNode
        testId="tree-node-types-#{memberKey}"
        id={memberKey}
        label={memberKey}
      />
    )
    path: "all_types/#{memberKey}"
    key: memberKey
    memberKey: memberKey
    type: Types.TYPES
    onExpand: (props) ->
      props.memberKey = memberKey
      getNestedTypes(props)
  }

getTypeTreeNodePath = ({ uid, graph }, memberKey) ->
  if getMemberKeys().length is 1 then "all_types/#{getUid(uid, graph)}" else "all_types/#{memberKey}/#{getUid(uid, graph)}"

export typeTreeNode = (type, props) ->
  if type.label is 'null' then type.label = type.uid
  {
    key: getUid(type.uid, type.graph)
    path: getTypeTreeNodePath(type, props.memberKey)
    type: Types.TYPE
    selectable: true
    memberKey: props.memberKey
    title: (
      <ContextMenu actions={ctxMenuProps(type)}>
        <BaseTreeNode
          testId={"#{getTypeTreeNodePath(type, props.memberKey)}"}
          id={getUid(type.uid, type.graph)}
          label="#{getNamespaceLabel(type.label || type.uid)} (#{type.count})"
        />
      </ContextMenu>
    )
    isLeaf: true
  }

ctxMenuProps = (node) -> [
  {
    key: "instantiate-#{ getNamespaceLabel(node.label) }-button"
    danger: false
    title: "Create a new #{ getNamespaceLabel(node.label) }"
    onClick: ({ domEvent }) ->
      domEvent.stopPropagation()
      showActionsPage(await InitiateTypeService.getInitiateTypeConfig(node.uid, node?.graph))
  }
]

export default {
  [Types.TYPE]: (type, { history }) ->
    store.dispatch(setCurrentItem({
      id: type.key
      type: Types.NODE
      label: type.label
      memberKey: type.memberKey
      viewType: Types.VIEWTYPE.ABSTRACT
      ranAt: getCurrentTimeInMillis()
    }))
    store.dispatch(setTabDisabled({ key: 'attributes', disabled: false })) if type.key
    params = getUpdatedSearchParams('tab', 'attributes')
    { explore: { tabIsLocked }} = store.getState()
    history.push({ pathname: window.location.pathname, search: params }) unless tabIsLocked
  [Types.TYPES]: (type, { history }) ->
    if type.memberKey isnt undefined or getMemberKeys().length < 2
      item = {
        type: Types.QUERY
        data: {
          viewType: Types.VIEWTYPE.ABSTRACT
          memberKey: type.memberKey
          query: "{}"
        }
        ranAt: getCurrentTimeInMillis()
      }
      { explore: { typesMap }} = store.getState()
      if _.keys(typesMap).length > 0 then store.dispatch(setCurrentItem(item))
}
